import { render, staticRenderFns } from "./TableProjectItem.vue?vue&type=template&id=7e22c5d3&scoped=true"
import script from "./TableProjectItem.vue?vue&type=script&lang=js"
export * from "./TableProjectItem.vue?vue&type=script&lang=js"
import style0 from "./TableProjectItem.vue?vue&type=style&index=0&id=7e22c5d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e22c5d3",
  null
  
)

export default component.exports